/*
 * SS05666 — the query payload posted to /api/document/export and /api/document/exportRequest.
 *
 * Two components offer "Export Data" (the list view and the listing toolbar) and each used to
 * build this object itself. Both carried the filters and neither carried the sort, so exporting a
 * sorted listing produced an unsorted file. One builder so they cannot drift again — and so the
 * next field added to the payload is added once.
 *
 * `sorts` is the same shape the list query sends, and the server reads it through
 * Processors/ListSortBuilder, which also applies the restricted-field rule.
 *
 * SS06127: `search` is the list view's search box. The server ANDs it on exactly as the list
 * query does (DocumentController.ApplySearch), so a searched list exports only what it shows.
 */
export function buildExportPayload({ listingId, moduleId, filters, sorts, contextId, search }) {
  return {
    parameters: {
      list: listingId,
      vectorId: moduleId,
      queryFilters: filters,
      // Explicit null rather than undefined: undefined would be dropped by JSON.stringify, so an
      // unsorted listing and a missing field would look identical on the wire.
      sorts: sorts || null,
      context: contextId != null ? contextId : null,
      search: search || null,
    },
  };
}

/*
 * SS06127: what the list view's query is narrowed by, for the export to send the same.
 * FTSListView.loadWorkspaceList sends the search box term only while the advanced filter is off,
 * and then sends NO filters: the query designer is hidden, and the filters kept in state (for
 * toggling back) are not what the list is showing. With nothing typed the export keeps sending
 * the filters, as it always has.
 */
export function exportQueryScope({ advancedFilter, filters, searchTerm }) {
  if (!advancedFilter && searchTerm) {
    return { filters: null, search: searchTerm };
  }

  return { filters, search: null };
}

export default buildExportPayload;
